export enum Status {
	IMMEDIATE = 3,
	MAINTENANCE_1_5_YEARS = 2,
	MAINTENANCE_5_10_YEARS = 1,
}

export const timeframeMap = {
	[Status.IMMEDIATE]: 'IMMEDIATE',
	[Status.MAINTENANCE_1_5_YEARS]: 'MAINTENANCE_1_5_YEARS',
	[Status.MAINTENANCE_5_10_YEARS]: 'MAINTENANCE_5_10_YEARS',
};
